import type { OutputFormat } from '../types'

const OPTIONS: { value: OutputFormat; label: string }[] = [
  { value: 'jpg', label: 'JPG / JPEG' },
  { value: 'png', label: 'PNG' },
  { value: 'pdf', label: 'PDF' },
]

interface FormatSelectorProps {
  value: OutputFormat
  onChange: (value: OutputFormat) => void
}

export default function FormatSelector({ value, onChange }: FormatSelectorProps) {
  return (
    <fieldset className="control">
      <legend className="control-head">
        <span>Convert to</span>
        <span>Output format</span>
      </legend>
      <div className="segment" role="radiogroup" aria-label="Output format">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={value === opt.value}
            className={value === opt.value ? 'selected' : ''}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
